import { Alert, Icon } from "@optimed/react";
import React from "react";

interface ErrorViewProps {
  title: string;
  message: string;
}

export function ErrorView(props: ErrorViewProps) {
  return (
    <Alert type="danger" className="mb-0">
      <small>
        <div>
          <Icon icon="exclamation-triangle" /> <span className="font-weight-bold">{props.title}</span>
        </div>
        <span>{props.message}</span>
      </small>
    </Alert>
  );
}
